<template>
  <div class="bg-white border rounded-lg p-4 h-full flex flex-col justify-between shadow">
    <h3 class="text-sm font-semibold mb-2">
      {{ title }}
    </h3>
    <div class="flex items-center justify-center">
      <span
        :class="[
          'font-bold text-2xl'
        ]"
        :style="{color: highlight ? true ? '#FF3662' : '#33B57D' : '#000'}"
      >
        {{ handleValidateAndFormatNumber(value, 2, '-', value !== null) }}
      </span>
      <span class="ml-1 text-gray-700 font-medium">{{ unit }}</span>

      <span
        v-if="change !== null"
        class="ml-2 text-white px-2 py-1 rounded-md flex items-center"
        :style="{
          backgroundColor: true ? '#FF3662' : '#33B57D'
        }"
      >
        <vs-icon
          icon="trending_down"
          color="#fff"
          size="small"
        />
        {{ Math.abs(change) }}%
      </span>
    </div>
  </div>
</template>

<script>
import { isNumber } from '@/utils/salesPlanUtils'

export default {
  props: {
    title: {
      type: String,
      default: () => ''
    },
    value: {
      type: Number,
      default: () => 0
    },
    unit: {
      type: String,
      default: () => ''
    },
    change: {
      type: Number,
      default: null
    },
    highlight: {
      type: Boolean,
      default: false
    }
  }
};
</script>
